/* kh-warenkorb.js — gemeinsame Warenkorb-Helfer für Katalog, Produktseite
   und Schnellbestellung. Eine Datei, damit Preisrechnung, Fehlerbehandlung
   und die Aktualisierung des Zählers in der Kopfzeile an einer Stelle stehen.

   window.KH.staffelPreis(kette, menge)  -> Cent je Stück für diese Menge
   window.KH.geld(cent)                  -> "3,90 €"
   window.KH.inDenWarenkorb(items, knopf)-> Promise; items = [{id, quantity}]
*/
(function () {
  'use strict';
  var KH = window.KH = window.KH || {};

  KH.geld = function (cent) {
    var v = (Math.round(cent) / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  };

  KH.zahl = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };

  /* kette: "10:390,100:390,240:390,10080:355" (aufsteigend nach Menge) */
  KH.staffel = function (kette) {
    return (kette || '').split(',').filter(Boolean).map(function (p) {
      var t = p.split(':');
      return { ab: parseInt(t[0], 10), preis: parseInt(t[1], 10) };
    }).sort(function (a, b) { return a.ab - b.ab; });
  };

  KH.staffelPreis = function (kette, menge) {
    var stufen = KH.staffel(kette);
    if (!stufen.length) return 0;
    var preis = stufen[0].preis;
    for (var i = 0; i < stufen.length; i++) {
      if (menge >= stufen[i].ab) preis = stufen[i].preis;
    }
    return preis;
  };

  KH.staffelStufe = function (kette, menge) {
    var stufen = KH.staffel(kette), idx = 0;
    for (var i = 0; i < stufen.length; i++) { if (menge >= stufen[i].ab) idx = i; }
    return idx;
  };

  /* Menge auf Mindestmenge und Schrittweite runden */
  KH.mengeNormieren = function (menge, moq, schritt) {
    menge = parseInt(menge, 10) || 0;
    moq = parseInt(moq, 10) || 1;
    schritt = parseInt(schritt, 10) || 1;
    if (menge <= 0) return 0;
    if (menge < moq) menge = moq;
    var rest = menge % schritt;
    if (rest) menge += schritt - rest;
    return menge;
  };

  /* Mengen-Stepper: <div class="kh-menge" data-moq data-schritt> <button data-minus> <input> <button data-plus> */
  KH.stepperBinden = function (wurzel) {
    (wurzel || document).querySelectorAll('.kh-menge').forEach(function (el) {
      if (el.dataset.gebunden) return;
      el.dataset.gebunden = '1';
      var input = el.querySelector('input');
      var moq = parseInt(el.dataset.moq, 10) || 1;
      var schritt = parseInt(el.dataset.schritt, 10) || 1;
      var nullErlaubt = el.dataset.nullErlaubt === '1';
      function setze(v) {
        v = parseInt(v, 10) || 0;
        if (v <= 0) v = nullErlaubt ? 0 : moq;
        else v = KH.mengeNormieren(v, moq, schritt);
        input.value = v;
        input.dispatchEvent(new CustomEvent('kh:menge', { bubbles: true, detail: { menge: v } }));
      }
      el.querySelector('[data-minus]').addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 0) - schritt;
        if (v < moq) v = nullErlaubt ? 0 : moq;
        setze(v);
      });
      el.querySelector('[data-plus]').addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        setze(v < moq ? moq : v + schritt);
      });
      input.addEventListener('change', function () { setze(input.value); });
      input.addEventListener('focus', function () { input.select(); });
    });
  };

  function zaehlerSetzen(anzahl) {
    document.querySelectorAll('[data-kh-cart-count]').forEach(function (b) {
      b.textContent = anzahl;
      b.hidden = anzahl === 0;
    });
  }

  KH.inDenWarenkorb = function (items, knopf) {
    if (!items || !items.length) return Promise.resolve();
    var alt = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = '…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      if (!res.ok) {
        var msg = (res.body && (res.body.description || res.body.message)) || 'Nicht hinzugefügt';
        if (window.khToast) window.khToast('Warenkorb', msg);
        throw new Error(msg);
      }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      zaehlerSetzen(cart.item_count);
      var stueck = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      if (window.khToast) window.khToast('Im Warenkorb', KH.zahl(stueck) + ' Stück · ' + KH.zahl(cart.item_count) + ' gesamt');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (knopf) { knopf.textContent = '✓ Hinzugefügt'; setTimeout(function () { knopf.textContent = alt; knopf.disabled = false; }, 1400); }
      return cart;
    })
    .catch(function (e) {
      if (knopf) { knopf.textContent = alt; knopf.disabled = false; }
      console.warn('[kh] Warenkorb:', e.message);
    });
  };

  /* Einzelne Knöpfe: <button data-kh-add data-variant="123"> in einer Zeile mit .kh-menge */
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-kh-add]');
    if (!k) return;
    e.preventDefault();
    var zeile = k.closest('[data-kh-zeile]') || k.closest('tr') || document;
    var input = zeile.querySelector('.kh-menge input');
    var menge = input ? parseInt(input.value, 10) : 1;
    if (!menge || menge < 1) return;
    KH.inDenWarenkorb([{ id: parseInt(k.dataset.variant, 10), quantity: menge }], k);
  });

  document.addEventListener('DOMContentLoaded', function () { KH.stepperBinden(document); });
})();
